import * as React from 'react';

import { CenterAbsoluteStyle, Dim } from '@components/Styles/CommonStyle';
import CircularProgress from '@mui/material/CircularProgress';

const Loading = () => {
  return (
    <Dim>
      <CenterAbsoluteStyle>
        <CircularProgress size={40} />
      </CenterAbsoluteStyle>
    </Dim>
  );
};

export default Loading;
